export default {
  name: "mPass",
  props: {
    label: null
  }
};